import { LoadingSpinner } from "../../loading-spinner/LoadingSpinner"
import "../styles/_donut-chart.scss"

export function DonutChartLoader() {
  return (
    <div className="donut-chart donut-chart--loading">
      <LoadingSpinner className="donut-chart__loader" />
    </div>
  )
}
